import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { OrderAndQuoteSettingsPageInitialData } from "./orderAndQuoteSettingsPageInitialData";

export const ORDER_AND_QUOTE_SETTINGS_PAGE_ID = "my-account/orderAndQuoteSettings";

export const orderAndQuoteSettingsPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.orderAndQuoteSettings(),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<OrderAndQuoteSettingsPageInitialData>>(
        `/page-data/${ORDER_AND_QUOTE_SETTINGS_PAGE_ID}`,
      ),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
